import {useQuery, useMutation} from "@tanstack/react-query";
import axios from "axios";

interface operationalTeamData {
	team_name: string;
    operational_cost: number;
    index?: string;
}

export const useGetOperationalTeams = () => {
	const url = 'https://api.concept.lawscore.com';

	const queryFn = async (): Promise<operationalTeamData[]> => {
		const response = await axios.get(
			`${url}/api/operational_teams`
		);
		const data: any = response.data;

		return data.data;
	};

	return useQuery<operationalTeamData[]>({
		queryKey: [
			"Operational-Teams"
		],
		queryFn: queryFn,
		refetchOnWindowFocus: false
	});
};

// TODO: Implement this later
export const useChangeOperatinalTeamInfo = (
    onSuccess = (data: any, variables: any, context: any) => {},
    onFailure = (error: any, variables: any, context: any) => {},
    onMutate = (variables: any) => {}
) => {
	const url = process.env.REACT_APP_API_URL || 'https://api.concept.lawscore.com';

	const mutate = async (mutationData: any): Promise<any> => {
		const response = await axios.post(
			`${url}/api/operational_teams`,
            mutationData.data
		);
		const data: any = response.data;
		return data;
	};

	return useMutation({
        mutationFn: mutate,
        onSuccess: onSuccess,
        onError: onFailure,
        onMutate: onMutate
	});
};
